import { Injectable } from "@angular/core";
import { JobDataService } from "./job-data.service";

@Injectable()
export class RouterService {

  constructor(private jobDataService: JobDataService) {
  }
  
  public GetStartRouteParams(trade: string): StartRouteParams {
    let isMember = false;
    
    if (this.jobDataService.capability.hasMemberShip) {
        isMember = this.jobDataService.capability.memberShipConfig.answer;
    }
    
    let postcode = this.jobDataService.postcode;
    
    return new StartRouteParams(trade, isMember, postcode);
  }

}

export class StartRouteParams {
    public isMember: boolean;
    public trade: string;
    public postcode: string;
    
    constructor(trade: string, isMember: boolean, postcode: string) {
        this.trade = trade;
        this.isMember = isMember;
        this.postcode = postcode;
    }
}